
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brak-numeru-pesel",
      function () {
        return require("private-next-pages/brak-numeru-pesel.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brak-numeru-pesel"])
      });
    }
  